import * as npm  from '../../package.json';

export const environment = {
  production: true,
  VERSION: npm.version,
  aplicativo: 'Asuntos internacionales',
  dataServiceUrl: 'https://api-sim.minjusticia.gov.co/dai',
  dataServiceMisionalUrl: 'https://api-sim.minjusticia.gov.co/sim',
  urls: {
    SIM: 'https://sim.minjusticia.gov.co/',
    SICEQ: 'https://api-sim.minjusticia.gov.co/siceq'
  },
  CodigoDAI : 1,
  modulos: {
    repatriaciones: '2',
    extradiciones: '3',
    asistenciaJudicial: '4'
  },
  roles: {
    tecnicoExtradicionesActivas: 'Técnico de extradiciones activas',
    tecnicoExtradicionesPasivas: 'Técnico de extradiciones pasivas',
    tecnicoExtradiciones:'Técnico de extradiciones'
  }
};
